import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { RouterModule } from "@angular/router";
import { InvitationStatusEnum } from "@models/invitation";
import { Transfer } from "@models/transfer";
import { InvitationStatusEnumPipe } from "@shared/pipes/invitation-status-enum.pipe";
import { PaginatorState } from "primeng/paginator";
import { environment } from "../../../../../../environments/environment";
import { ButtonComponent } from "../../../../../../shared/components/button/button.component";

@Component({
    selector: "app-transfer-invitation-card",
    imports: [
        CommonModule,
        ButtonComponent,
        InvitationStatusEnumPipe,
        RouterModule,
    ],
    templateUrl: "./transfer-invitation-card.component.html",
    styleUrl: "./transfer-invitation-card.component.scss"
})
export class TransferInvitationCardComponent {
  @Input({ required: true }) invitation!: Transfer;
  @Input() isLoading = false;

  @Output()
  acceptInvitationClick = new EventEmitter<number>();

  @Output()
  declineInvitationClick = new EventEmitter<number>();

  @Output()
  pageChange = new EventEmitter<PaginatorState>();

  invitationStatusEnum = InvitationStatusEnum;

  handleAcceptClick() {
    this.acceptInvitationClick.emit(this.invitation.id);
  }

  handleDeclineClick() {
    this.declineInvitationClick.emit(this.invitation.id);
  }

  loadEventImage(event_thumb: string) {
    return `${environment.BLOB_URL}/${event_thumb}`;
  }
}
